import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-chat-dynamic-table',
  templateUrl: './chat-dynamic-table.component.html',
  styleUrls: ['./chat-dynamic-table.component.scss']
})
export class ChatDynamicTableComponent implements OnInit {
  @Input() content!: any;

  constructor() {
  }

  ngOnInit(): void {
  }

  getTableHeaders(tableData: any[]): string[] {
    if (!tableData || tableData.length === 0) {
      return [];
    }

    // Get all unique keys from all objects in the array
    const headers = new Set<string>();
    tableData.forEach(row => {
      if (row && typeof row === 'object') {
        Object.keys(row).forEach(key => {
          headers.add(key);
        });
      }
    });

    return Array.from(headers);
  }

}
